import Reveal from "@/components/Reveal";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const FAQS = [
  {
    q: "How does the 80/20 profit sharing work?",
    a: "After agreed operating expenses are deducted from your property's monthly rental revenue, you receive 80% of the remaining profit and Shonta Solutions receives 20% in exchange for coordinating the day-to-day management of your rental.",
  },
  {
    q: "How does the $500 partnership incentive work?",
    a: "When you join our qualifying property management program, Shonta Solutions pays you a $500 partnership incentive once your property qualifies and the partnership requirements in our agreement are satisfied. The details are confirmed in your management agreement.",
  },
  {
    q: "Do I have to sign a lease with Shonta Solutions?",
    a: "No. Our partnership model is designed to manage your property on your behalf, without requiring us to become your tenant. You keep ownership of your property.",
  },
  {
    q: "What am I responsible for as the property owner?",
    a: "You remain responsible for property ownership expenses, approved maintenance costs, and other agreed operating expenses. Shonta Solutions handles the hospitality side: listings, marketing, bookings, guests, cleanings, and daily operations.",
  },
  {
    q: "Do you handle guest communication and cleaning?",
    a: "Yes. We coordinate guest inquiries, reservations, check-in instructions, and guest support, and we coordinate cleaning, turnover services, and maintenance needs with approved service providers.",
  },
  {
    q: "Can I still use my property?",
    a: "Yes, subject to existing reservations and the terms of your management agreement.",
  },
];

export default function Faq() {
  return (
    <section id="faq" className="py-20 sm:py-28 bg-white" data-testid="faq-section">
      <div className="max-w-2xl mx-auto px-5 sm:px-8">
        <Reveal className="text-center">
          <p className="text-sm font-bold tracking-[0.2em] uppercase text-[#FF5A5F]">Good to Know</p>
          <h2 className="mt-3 text-3xl sm:text-4xl font-bold tracking-tight text-[#222]">
            Frequently Asked Questions
          </h2>
        </Reveal>

        <Reveal className="mt-10">
          <Accordion type="single" collapsible className="w-full space-y-3" data-testid="faq-accordion">
            {FAQS.map((faq, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                data-testid={`faq-item-${i + 1}`}
                className="bg-[#F7F7F9] border border-[#EBEBEB] rounded-2xl px-6 overflow-hidden"
              >
                <AccordionTrigger
                  data-testid={`faq-trigger-${i + 1}`}
                  className="text-left text-base sm:text-lg font-bold text-[#222] hover:text-[#FF5A5F] hover:no-underline py-5"
                >
                  {faq.q}
                </AccordionTrigger>
                <AccordionContent className="text-[15px] leading-relaxed text-[#5a5a5a] pb-5">
                  {faq.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
}
